var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.$page.props.white_label.data.logo_white,"width":"120"}})
}
var staticRenderFns = []

export { render, staticRenderFns }